import { defineStore } from 'pinia'
interface UserGroup {
  "id": 1,
  "name": "默认分组",
  rules: string
  status: string
  update_time: number
  create_time: number
}
export const useUserGroup = defineStore('userGroup', {
  state: (): UserGroup[] => {
    return []
  },
  actions: {
    dataFill(state: UserGroup[]) {
      this.$state = state
    },
  },
  persist: {
    key: 'userGroup',
  },
})
